import React, { Component } from 'react';
import './PaywallModal.css';

// Recover paid download with Order ID + Guest Access Code
class RecoverDownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: props.initialOrderId || '',
      guestAccessCode: props.initialAccessCode || '',
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.props.onRecover) {
      this.props.onRecover({
        orderId: this.state.orderId.trim(),
        guestAccessCode: this.state.guestAccessCode.trim(),
      });
    }
  };

  render() {
    const { isOpen, onClose, loading, error } = this.props;
    if (!isOpen) {
      return null;
    }

    return (
      <div className="paywall-recover-overlay" onClick={onClose} role="presentation">
        <form
          className="paywall-recover-card"
          onClick={(e) => e.stopPropagation()}
          onSubmit={this.handleSubmit}
        >
          <button type="button" className="paywall-close" onClick={onClose} aria-label="Close">
            ×
          </button>
          <h2 className="paywall-title">Recover download</h2>
          <p className="paywall-text">
            Enter your Order ID and Guest Access Code from the payment success screen.
          </p>
          <label className="paywall-text" htmlFor="recover-order">
            Order ID
          </label>
          <div className="paywall-code-row">
            <input
              id="recover-order"
              value={this.state.orderId}
              onChange={this.handleChange('orderId')}
              required
            />
          </div>
          <label className="paywall-text" htmlFor="recover-code">
            Guest Access Code
          </label>
          <div className="paywall-code-row">
            <input
              id="recover-code"
              value={this.state.guestAccessCode}
              onChange={this.handleChange('guestAccessCode')}
              required
            />
          </div>
          {/* {error ? <p className="paywall-error">{error}</p> : null} */}
          <button type="submit" className="paywall-cta" disabled={loading}>
            {loading ? 'Checking…' : 'Unlock download'}
          </button>
        </form>
      </div>
    );
  }
}

export default RecoverDownloadModal;
